import { getAuth } from "firebase/auth";
import { app } from "../firebase";

const auth = getAuth(app);

export default async function isUserPremium() {
  try {
    // Force refresh to ensure we get the latest claims
    await auth.currentUser?.getIdToken(true);
    
    const decodedToken = await auth.currentUser?.getIdTokenResult();
    return decodedToken?.claims?.stripeRole === 'premium';
  } catch (error) {
    console.error('Error checking if user is premium:', error);
    return false;
  }
}